import React, { FC, useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { Helmet } from 'react-helmet'
import { LangValue } from '../../../../states/types/common'

import { URL } from '../../../constants/url'
import { setUrlId, setPath } from '../../../../utils/url'
import { cloneDeep, filter, sortBy } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tips from '../../../components/common/Tips'
import { compile } from '../../../../utils/search'

interface Team {
  id: number
  name: string
  members: {
    id: number
    active: boolean
    name: string
    place: string | null
    contract: string | null
    profile_image: string | null
  }[]
}

const Index: FC = () => {
  const { language } = useParams<{ language: LangValue }>()
  const history = useHistory()

  const {
    risk,
  } = useSelector((state: RootState) => (state))

  const [teamList, setTeamList] = useState<Team[]>()
  const [teamListInit, setTeamListInit] = useState<Team[]>()
  const [searchWord, setSearchWord] = useState<string>("")

  const search = (words: string) => {
    setSearchWord(words)
    if (!words) {
      setTeamList(cloneDeep(teamListInit))
      return
    }
    const word = words.split(/\s+/)
    const list = filter(teamListInit, (team) => {
      if (team === null) return false
      return (compile(word).test(team.name))
    }) as Team[]
    setTeamList(sortBy(list, 'id'))
  }

  const reset = () => {
    setSearchWord("")
    setTeamList(cloneDeep(teamListInit))
  }

  useEffect(() => {
    if (!risk.riskTeams?.teams) return
    setTeamListInit(risk.riskTeams.teams)
    setTeamList(risk.riskTeams.teams)
  }, [risk])

  const handleListClick = (teamId: number) => history.push(setPath(setUrlId(URL.RISK_TEAM_DETAIL.path, 'id', teamId), language))

  return (
    <section className="risk_page">
      <Helmet>
        <title>Qasee - リスクアセスメント - チーム一覧</title>
      </Helmet>
      <section className="breadcrumb">
        リスクアセスメント
        &nbsp;&gt;&nbsp;
        チーム一覧
        &nbsp;
      </section>
      <section className="page_header">
        <h1 className="question">
          チーム一覧
        </h1>
        <div className="tools">
          <div className="search_box">
            <input
              type="text"
              placeholder="キーワードでチーム検索"
              onChange={(event) => search(event.target.value)}
              value={searchWord}
            />
            {
              searchWord && (
                <button type="button" className="reset" onClick={reset}>
                  <FontAwesomeIcon icon={['far', 'times-circle']} />
                </button>
              )
            }
          </div>
        </div>
      </section>
      <section className="page_contents content-area">
        <section className="content content-area">
          <div className="content-block">
            <div className="block-header">
              <div className="title">
                チーム
              </div>
            </div>
            <div className="block-detail">
              <table className="flex-table team_table">
                <thead>
                  <tr>
                    <th>チーム名</th>
                    <th>メンバー</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    teamList && teamList.map((team: Team) => (
                      <tr key={team.id}>
                        <td>
                          <span className="link" onClick={() => handleListClick(team.id)} role="none">
                            {team.name}
                          </span>
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "4px",
                              border: "solid 1px #CCCCCC",
                              padding: "4px",
                            }}
                          >
                            {team.members.map((member) => (
                              <div
                                style={{
                                  backgroundColor: member.active ? "#dddddd" : "#dcecff",
                                  borderRadius: "20px",
                                  padding: "4px 8px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  position: "relative",
                                }}
                              >
                                {
                                  member.profile_image ? (
                                    <img
                                      alt="profile"
                                      src={member.profile_image}
                                      className="profile_icon"
                                      style={{
                                        borderRadius: "50%",
                                        width: "16px",
                                        height: "16px",
                                        margin: "0",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      alt=""
                                      src={`/static/images/profile/${(Number(member.id) || 0) % 12}.jpeg`}
                                      className="profile_icon"
                                      style={{
                                        borderRadius: "50%",
                                        width: "16px",
                                        height: "16px",
                                        margin: "0",
                                      }}
                                    />
                                  )
                                }
                                {member.name}
                                {
                                  member.active || (
                                    <Tips
                                      description="休眠中💤"
                                      className=""
                                      icon={false}
                                    >
                                      <>
                                        💤
                                      </>
                                    </Tips>
                                  )
                                }
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </section>
    </section>
  )
}

export default Index
